import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OptionsModalEnum } from 'src/app/common/options-modal';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { Place } from 'src/app/models/place.model';
import { ListData } from 'src/app/models/price-list.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { EditCategoryVendorRequest, Regimes, VendorResponse } from 'src/app/models/vendor.model';
import { DestinationService } from 'src/app/services/destination.service';
import { PlaceService } from 'src/app/services/place.service';
import { UserService } from 'src/app/services/user.service';
import { VendorBillingNitService } from 'src/app/services/vendor-billing-nit.service';
import { VendorService } from 'src/app/services/vendor.service';
declare let $: any;

@Component({
  selector: 'app-modal-vendor',
  templateUrl: './modal-vendor.component.html',
  styleUrls: ['./modal-vendor.component.scss']
})
export class ModalVendorComponent implements OnInit {
  @Input() newVendor = new VendorResponse();
  @Input() isCreating: boolean = true;
  loading = false;
  @Output() close = new EventEmitter<boolean>();
  currentStep = 1;
  inputCategory = new InputAutocompleteModel("", false, true, "", "", "", "", null, []);
  steps = [1, 2, 3];
  regimes: Regimes[] = [];
  custom = false;
  lists: ListData[] = [];
  allCategories = [];
  searchCategory = "";
  timeoutNit = null;
  autocomplete = false;
  enableBillingData: boolean = false;
  places: Place[] = [];
  billingNitInput: string = "";
  billingNameInput: string = "";

  constructor(
    private vendorService: VendorService,
    private placeService: PlaceService,
    private destinationService: DestinationService,
    private toastService: ToastrService,
    private userService: UserService,
    private vendorBillingNitService: VendorBillingNitService
  ) {

  }

  ngOnInit(): void {
    this.getRegimes();
    this.getPriceLists();
    this.getAllCategories();
    this.getDestinations();
    this.syncEnableBillingFromModel();
    this.getBillingNits();
  }

  writeNit() {
    if (!this.newVendor.nit || this.newVendor.nit.length==0) {
      return
    }
    clearTimeout(this.timeoutNit);
    this.timeoutNit = setTimeout(() => {
      this.userService.checkNIT(this.newVendor.nit).subscribe({
        next: (response: ResponseObject) => {
          if (response.data.length > 0 && response.data.length == 1) {
            this.newVendor.name = response.data[0].name;
            this.autocomplete = true;
          } else {
            this.newVendor.name = "";
            this.autocomplete = false;
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.success(error.error.message);
        }
      })
    }, 400);
  }

  writeCategory() {
    this.inputCategory.filterElements = this.allCategories.filter((category) => {
      return category.name.toLowerCase().includes(this.inputCategory.value.toLowerCase())
    })
    this.inputCategory.verified = false;
    this.inputCategory.data = null;
    if (this.inputCategory.filterElements.length == 0) {
      this.inputCategory.class = "fa-circle-plus text-info";
      this.inputCategory.bgColor = "for-info";
      return;
    }
    this.inputCategory.class = "fa-list";
  }

  selectCategory(category) {
    this.inputCategory.value = category.name;
    this.inputCategory.class = "fa-circle-check";
    this.inputCategory.verified = true;
    this.inputCategory.data = category;
  }

  questionForModal = null;
  addCategory() {
    if (this.inputCategory.data) {
      this.addToListCategory(this.inputCategory.data);
    } else {
      if (this.inputCategory.filterElements.length == 0) {
        this.questionForModal = "Se creará la categoría " + this.inputCategory.value;
      }
    }
  }

  closeCreateCategory(option) {
    if (option == OptionsModalEnum.ACCEPT) {
      this.saveCategory();
    } else {
      this.questionForModal = null;
    }
  }

  saveCategory() {
    this.vendorService.createCategoryVendor(this.inputCategory.value).subscribe({
      next: (response: ResponseObject) => {
        var newCategory = response.data as EditCategoryVendorRequest;
        this.inputCategory.data = newCategory;
        this.getAllCategories();
        this.addToListCategory(newCategory);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  addToListCategory(cat) {
    if (!this.newVendor['categories']) {
      this.newVendor['categories'] = [];
    }
    var findOut = this.newVendor['categories'].find((category) => {
      return category.id == cat.id;
    });
    this.inputCategory.value = "";
    this.inputCategory.class = "fa-list";
    this.inputCategory.data = null;
    if (findOut) {
      this.toastService.info("Ya se agrego la categoria");
    } else {
      this.newVendor['categories'].push(cat);
      this.searchCategory = "";
    }
    this.questionForModal = null;
  }

  select() {
    var temp = this.allCategories.filter((category) => {
      return category.id + "" == this.searchCategory || category.name.toLowerCase().includes(this.searchCategory.toLowerCase())
    });
    if (temp.length == 1) {
      if (!this.newVendor['categories']) {
        this.newVendor['categories'] = [];
      }
      var newCategory = temp[0];
      var findOut = this.newVendor['categories'].find((category) => {
        return category.id == newCategory.id;
      });
      if (findOut) {
        this.toastService.info("Ya se agrego la categoria");
      } else {
        this.newVendor['categories'].push(newCategory);
        this.searchCategory = "";
      }
    } else {
      this.toastService.info("No existe la categoria");
    }
  }

  deleteCategory(indexCategory: number) {
    this.newVendor['categories'].splice(indexCategory, 1);
  }

  getAllCategories() {
    this.vendorService.getAllCategoriesVendor().subscribe({
      next: (response: ResponseObject) => {
        this.allCategories = response.data;
        this.inputCategory.filterElements = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  getPriceLists() {
    this.vendorService.getPriceLists().subscribe({
      next: (response: ResponseObject) => {
        this.lists = response.data;

      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }


  getDestinations() {
    this.destinationService.getDestinationsActive(true).subscribe({
      next: (response: ResponseObject) => {
        this.places = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  customizable() {
    if (this.custom) {
      if (this.newVendor.providerCreditDays % 30 != 0) {
        this.newVendor.providerCreditDays = Math.floor(this.newVendor.providerCreditDays / 30) * 30;
      }
      if (this.newVendor.providerCreditDays > 90) {
        this.newVendor.providerCreditDays = 90;
      }
    }
    this.custom = !this.custom;
  }

  nextStage1() {
    if (this.newVendor.provider) {
      this.currentStep = 2;
    } else {
      this.currentStep = 3;
    }
    this.updateProgressBar();
  }

  getRegimes() {
    this.vendorService.getRegimes().subscribe({
      next: (response: ResponseObject) => {
        this.regimes = response.data;

      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  updateProgressBar() {
    var progressPercentage = ((this.currentStep - 1) / 2) * 100;
    $(".progress-bar").css("width", progressPercentage + "%");
  }


  displayStep(stepNumber) {
    if (stepNumber > 1) {
      if (!this.newVendor.name || !this.newVendor.nit) {
        return;
      }
      if (stepNumber == 3 && this.newVendor.provider && (!this.newVendor.taxRegime)) {
        return;
      }
    }
    if (stepNumber >= 1 && stepNumber <= 3) {
      $(".step-" + this.currentStep).hide();
      $(".step-" + stepNumber).show();
      this.currentStep = stepNumber;
      this.updateProgressBar();
    }
  }

  changeProvider() {


  }

  changeClient() {
    this.newVendor.priceList = !this.newVendor.priceList ? -1 : null;
  }

  onBillingDataToggle(): void {
      this.billingNitInput = "";
      this.billingNameInput = "";

      if (!this.enableBillingData) {
          this.newVendor.billingRequest = [];
      }
  }

  editOrSave() {
    this.loading = true;
    var temp = [];
    if (this.newVendor['categories']) {
      this.newVendor['categories'].forEach(element => {
        temp.push(element.id);
      });
      this.newVendor['categories'] = temp;
    }
    if (this.newVendor.priceList == -1) {
      this.newVendor.priceList = null;
    }
    if (this.newVendor.percentage < 0 || this.newVendor.percentage > 100) {
      this.loading = false;
      this.toastService.error("El procentaje debe estar entre 0 y 100")
      return;
    }
    if (this.newVendor.clientCredit != null && this.newVendor.clientCredit < 0) {
      this.loading = false;
      this.toastService.error("El credito es incorrecto")
      return;
    }
    // if (!this.enableBillingData) {
    //   this.newVendor.billingNit = null;
    //   this.newVendor.billingName = null;
    // } else {
    //   if (!this.newVendor.billingNit || !this.newVendor.billingName) {
    //     this.loading = false;
    //     this.toastService.error("Debes ingresar NIT y Nombre de facturación");
    //     return;
    //   }
    // }

    if (!this.newVendor.billingRequest) {
      this.newVendor.billingRequest = [];
    }

    if (this.isCreating) {
      this.vendorService.postVendor(this.newVendor).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Se ha agregado correctamente!");
          this.newVendor = new VendorResponse();
          this.loading = false;
          this.enableBillingData = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error(error.error.message);
        }
      })
    } else {
      this.vendorService.putVendor(this.newVendor).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Se ha modificado correctamente!");
          this.newVendor = new VendorResponse();
          this.loading = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error(error.error.message);
        }
      })
    }
  }

  previousStage3() {
    if (this.newVendor.provider) {
      this.currentStep = 2;
    } else {
      this.currentStep = 1;
    }
    this.updateProgressBar();
  }

  private syncEnableBillingFromModel(): void {
      if (!this.newVendor.billingRequest) {
          this.newVendor.billingRequest = [];
      }
      this.enableBillingData =this.newVendor.billingRequest.length > 0;
  }

  ngOnChanges(): void {
    this.syncEnableBillingFromModel();
  }

  addBillingData(): void {
      const billingNit = this.billingNitInput
          ? this.billingNitInput.trim()
          : "";

      const billingName = this.billingNameInput
          ? this.billingNameInput.trim()
          : "";

      if (!billingNit || !billingName) {
          this.toastService.info(
              "Debes ingresar el NIT y el nombre de facturación"
          );
          return;
      }

      if (!this.newVendor.billingRequest) {
          this.newVendor.billingRequest = [];
      }

      const exists = this.newVendor.billingRequest.some(item =>
          item.billingNit &&
          item.billingNit.trim().toLowerCase() === billingNit.toLowerCase()
      );

      if (exists) {
          this.toastService.info(
              "El NIT de facturación ya se encuentra agregado"
          );
          return;
      }

      this.newVendor.billingRequest.push({
          billingNit: billingNit,
          billingName: billingName
      });

      this.billingNitInput = "";
      this.billingNameInput = "";
  }

  deleteBillingData(index: number): void {

      if (!this.newVendor.billingRequest) {
          return;
      }

      this.newVendor.billingRequest.splice(index, 1);
  }

  getBillingNits(): void {
      if (this.isCreating || !this.newVendor?.id) {
          this.newVendor.billingRequest = [];
          this.enableBillingData = false;
          return;
      }

      this.vendorBillingNitService
          .getVendorBillingNitById(this.newVendor.id)
          .subscribe({
              next: (response: any) => {

                  const data = response.data || [];

                  this.newVendor.billingRequest = data.map(item => ({
                      billingNit: item.billingNit,
                      billingName: item.billingName
                  }));

                  this.enableBillingData =
                      this.newVendor.billingRequest.length > 0;
              },
              error: (error: HttpErrorResponse) => {
                  this.toastService.error(
                      error.error?.message ||
                      "No se pudieron cargar los datos de facturación"
                  );
              }
          });
  }

  isCellphoneRequired(): boolean {
      return (
          this.newVendor.client === true &&
          this.newVendor.nit?.trim().toUpperCase() === 'CF'
      );
  }

}
